import { useEffect, useState } from "react";
import { useAppSelector } from "@/state/hooks";

/** Quiet period after the last ticket_* frame before views re-fetch. */
export const TICKET_EVENT_SETTLE_MS = 300;

/**
 * chatSlice's `ticketEventSeq`, but only once frames have stopped arriving
 * for TICKET_EVENT_SETTLE_MS — so a burst of ticket_* frames (every
 * supporter gets each one) becomes one re-fetch per view, not one per frame.
 * Starts at the current seq, so mounting doesn't wait. The pending timer is
 * cleared on every new frame and on unmount.
 */
export function useSettledTicketEventSeq(): number {
  const seq = useAppSelector((s) => s.chat.ticketEventSeq);
  const [settled, setSettled] = useState(seq);

  useEffect(() => {
    if (seq === settled) return;
    const id = window.setTimeout(() => setSettled(seq), TICKET_EVENT_SETTLE_MS);
    return () => window.clearTimeout(id);
  }, [seq, settled]);

  return settled;
}
